export default {
  'hackathon-slide': () => import('@/components-v2/presentation-editor/middle/SlideContentHackathon.vue'),
  embed: () => import('@/components-v2/presentation-editor/middle/EmbedSlideCastingView.vue'),
}
